export default "<abw-page-builder-hseparator [model]=\"model\" style=\"flex: 1\"></abw-page-builder-hseparator>";